<template>
  <div class="mb-2">
    <div class="collapse border rounded-lg bg-base-100">
      <!-- Checkbox to control collapse state -->
      <input
        type="checkbox"
        :checked="isDefaultOpen"
        class="collapse-checkbox"
      />

      <div class="collapse-title text-sm">
        {{ travel.vehicle.organization }}
        ({{ travel.vehicle.info }}, {{ travel.driver.info }})
      </div>

      <div class="collapse-content text-xs">
        <div>
          Atstumas:
          <span
            :class="{
              'badge badge-warning badge-sm': travel.length > 400,
            }"
          >
            {{ travel.length }} km
          </span>
        </div>
        <div>Organizuoja: {{ travel.organization.info }}</div>
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <div v-for="trip in travel.trips" :key="trip.id" class="mt-3">
            Pavėžėjimas: {{ trip.id }} <br />
            <div class="mt-1">
              <div v-for="waypoint in trip.waypoints" :key="waypoint.id">
                {{ waypoint.time }} - {{ waypoint.address }}
              </div>
            </div>
            <div class="flex items-center gap-2 mt-1">
              <span>Keleiviai:</span>
              <div class="flex items-center gap-1">
                <span>{{ trip.person_regular_count }}</span>
                <DefaultIcon name="passenger" size="w-4 h-4" />
              </div>
              <div class="flex items-center gap-1">
                <span>{{ trip.person_disabled_count }}</span>
                <DefaultIcon name="wheelchair" size="w-4 h-4" />
              </div>
            </div>
            <div class="mt-1">
              <template
                v-for="(client, index) in trip.clients"
                :key="client.id"
              >
                <router-link
                  :to="`/clients/${client.id}/edit`"
                  class="hover:underline"
                >
                  {{ client.name }}
                  {{ client.surname }} </router-link
                >{{ index < trip.clients.length - 1 ? ", " : "" }}
              </template>
            </div>
            <div v-if="trip.child_seat_needed" class="mt-1">
              Reikalinga vaikiška kėdutė
            </div>
            <div v-if="trip.wheelchair_needed" class="mt-1">
              Reikalingas neįgaliojo vežimėlais
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps } from "vue";
import { useAuthStore } from "@/stores/auth"; // Adjust the import path as needed
import DefaultIcon from "@/components/icons/DefaultIcon.vue"; // Adjust the import path as needed

// Define props
const props = defineProps({
  travel: {
    type: Object,
    required: true,
  },
});

// Get auth store
const authStore = useAuthStore();

// Compute whether this item should be open by default
const isDefaultOpen = computed(
  () => props.travel.vehicle.organization === authStore.user.organization.name,
);
</script>

<style scoped>
.collapse-checkbox,
.collapse-title {
  min-height: 2em !important;
  padding: 0.5rem !important;
}
</style>
